export const useLocalStorage = defineStore('localStorage', () => {
  const authToken = ref<string | null>(null)
  const multiLlmLastThreadId = ref<string>('')
  const multiLlmAuthToken = ref<string>('')
  const multiLlmPopupData = ref<string>('')
  const sourceRelatedQuestion = ref<string>('')

  function setAuthToken(value: string) {
    authToken.value = value
  }

  function setMultiLlmLastThreadId(value: string) {
    multiLlmLastThreadId.value = value
  }

  function setMultiLlmAuthToken(value: string) {
    multiLlmAuthToken.value = value
  }

  function setMultiLlmPopupData(value: string) {
    multiLlmPopupData.value = value
  }

  // 마지막으로 선택했던 출처 정보 반환
  function getSourceRelatedQuestion() {
    return sourceRelatedQuestion.value
  }

  // 마지막으로 선택했던 출처 정보 저장
  function setSourceRelatedQuestion(SourceTitle: string) {
    sourceRelatedQuestion.value = SourceTitle
  }

  return {
    authToken,
    setAuthToken,
    multiLlmLastThreadId,
    setMultiLlmLastThreadId,
    multiLlmAuthToken,
    setMultiLlmAuthToken,
    multiLlmPopupData,
    setMultiLlmPopupData,
    getSourceRelatedQuestion,
    setSourceRelatedQuestion
  }
})
